import "./NewRowItem.less";

import { Alert, Select } from "antd";
import React from "react";

import { User } from "lib/data/model";

import { AddNewButton } from "components/general/StandardButtons";
import { orderBy } from "lodash";

interface INewRowItemProps {
	users: User[];
	disabled?: boolean;
	addNewUser(user: User): Promise<boolean>;
}

interface INewRowItemState {
	selectedUser?: User;
	error?: string;
	success?: string;
	value?: number;
}

export class NewRowItem extends React.Component<INewRowItemProps, INewRowItemState> {

	constructor(props: INewRowItemProps) {

		super(props);

		this.state = {

		};
	}

	public resetSelectValue = () => {

		this.setState({selectedUser: undefined});
	}

	public render() {

		return (
			<div className="new-row-item">
				<div className="add-user">
					<Select
						showSearch={true}
						placeholder="Select a person"
						onChange={this.onChange}
						disabled={this.props.disabled}
						value={this.state.selectedUser ? this.state.selectedUser.id : undefined}
						filterOption={this.userSearchFilter}
					>
						{
							orderBy(this.props.users, [(user) => `${user.firstName} ${user.lastName}`.toLowerCase()], ["asc"])
							.map((user, key) => (
								<Select.Option value={user.id} key={key}>
									{user.firstName} {user.lastName}
								</Select.Option>
							))
						}
					</Select>

					<AddNewButton onClick={this.newUserClick} disabled={this.props.disabled} />
				</div>
				<div className="message-container">

					{this.state.success
						?
						<Alert message={this.state.success} type="success" />
						:
						null
					}

					{this.state.error
						?
						<Alert message={this.state.error} type="error" />
						:
						null
					}
				</div>
			</div>
		);
	}

	private userSearchFilter = (input: string, option: React.ReactElement<any>): boolean => {

		return option.props.children.join("").toLowerCase().indexOf(input.toLowerCase()) >= 0;
	}

	private newUserClick = async () => {

		if (this.state.selectedUser) {

			const added: boolean = await this.props.addNewUser(this.state.selectedUser);

			if (added) {

				this.setState({ success: "User added to section" });

				setTimeout(() => {

					this.setState({ success: undefined });
				}, 5000);

			}
			else {

				this.setState({ error: "Error adding user to section" });

				setTimeout(() => {

					this.setState({ error: undefined });
				}, 5000);
			}

		}
		else {

			this.setState({ error: "In order to add a user, you must select a user first" });

			setTimeout(() => {

				this.setState({ error: undefined });
			}, 5000);
		}

	}

	private onChange = (value: number) => {

		this.setState({selectedUser: this.props.users.find(user => user.id === value)});
	}
}
